import React from 'react';
import { pageHeroPhotos } from '../data/pageHeroPhotos';
import { Link } from 'react-router-dom';
import { ArrowRightIcon, PhoneIcon } from 'lucide-react';
import { PageHeading } from '../components/PageHeading';
import { TrustLocalBand } from '../components/TrustLocalBand';
import { business, currentSpecials } from '../data/site';
import { usePageMeta } from '../hooks/usePageMeta';
export function Specials() {
  usePageMeta('Current Auto Repair Specials in Oak Ridge, TN | East End Automotive Repair', 'Current specials at East End Automotive Repair in Oak Ridge, TN: free brake inspection with the purchase of brakes, $29.99 A/C pressure test, and a 5 qt oil change for $49.97 (not all oils apply; diesel and specialty oils excluded).');
  return <>
      <PageHeading photo={{
      ...pageHeroPhotos.specials,
      position: 'center 44%',
      mobilePosition: '58% 45%'
    }} eyebrow="Specials" title="Current Auto Repair Specials in Oak Ridge, TN" intro="Here is what is running right now at East End Automotive Repair. Call the shop to have one applied to your visit." data-id="element-785" data-mp="ecsgl0s1rec0" />

      <section className="w-full bg-white py-14 lg:py-20" data-id="element-786" data-mp="23cvdfl0igs6e">
        <div className="mx-auto max-w-shell px-5 lg:px-8" data-id="element-787" data-mp="27dfe2ykamdxa">
          <ul className="grid gap-5 md:grid-cols-3" data-id="element-788" data-mp="27bvxf6uq60uz">
            {currentSpecials.map(special => <li key={special.title} className="flex" data-id="element-789" data-mp="2cdtmihpt3pvu">
                <Link to={special.to} className="group flex w-full flex-col rounded-lg border border-black/10 bg-chalk p-6 transition-colors duration-150 ease-out hover:border-ink/40" data-id="element-790" data-mp="2hcen4i8z0bkt">
                  <span className="font-display text-[32px] font-extrabold leading-none tracking-tight text-brand-dark" data-id="element-791" data-mp="2r27wrdpjygmf">
                    {special.price}
                  </span>
                  <h2 className="mt-4 font-display text-[19px] font-bold leading-snug tracking-tight text-ink" data-id="element-792" data-mp="303fh0rv8hgxi">
                    {special.title}
                  </h2>
                  <p className="mt-2 text-[14.5px] leading-relaxed text-steel/70" data-id="element-793" data-mp="14yespesno0kk">
                    {special.detail}
                  </p>
                  {special.finePrint && <p className="mt-2 text-[13px] text-steel/55" data-id="element-794" data-mp="1eohk5ak4p6gs">
                      {special.finePrint}
                    </p>}
                  <span className="mt-auto flex items-center gap-1.5 pt-6 text-[12.5px] font-bold uppercase tracking-[0.08em] text-brand-dark" data-id="element-795" data-mp="19wgdc45qc7y5">
                    See details
                    <ArrowRightIcon className="h-4 w-4 shrink-0 transition-transform duration-150 ease-out group-hover:translate-x-0.5" aria-hidden="true" data-id="element-796" data-mp="1jmsudmec5izj" />
                  </span>
                </Link>
              </li>)}
          </ul>

          <p className="mt-8 max-w-[620px] text-[14.5px] leading-relaxed text-steel/65" data-id="element-797" data-mp="3a4b3bu1avkt">
            Exact terms: free brake inspection with the purchase of brakes;
            Complete A/C Pressure Test & System Inspection for $29.99 plus tax
            and shop fees; 5 qt oil change for $49.97 before taxes and shop
            fees. Not all oils apply. Diesel and specialty oils do not apply.
            Contact us for details.
          </p>
        </div>
      </section>

      <TrustLocalBand data-id="element-798" data-mp="256cxcqfjdadg" />

      <section className="w-full bg-ink py-14 text-white lg:py-16" data-id="element-799" data-mp="255jxm9ezvl4t">
        <div className="mx-auto flex max-w-shell flex-col gap-7 px-5 lg:flex-row lg:items-center lg:justify-between lg:px-8" data-id="element-800" data-mp="1r73oycxknkk1">
          <div data-id="element-801" data-mp="1w817wrqeoiml">
            <h2 className="max-w-[560px] font-display text-[26px] font-extrabold leading-[1.1] tracking-[-0.02em] sm:text-[32px]" data-id="element-802" data-mp="1w4dc1lxhnk4p">
              Call the shop to use a special
            </h2>
            <p className="mt-4 max-w-[520px] text-[16px] leading-relaxed text-chalk/70" data-id="element-803" data-mp="1m8inka6l2uu0">
              Mention the offer when you call and we will apply it to your
              visit.
            </p>
          </div>
          <div className="flex flex-col gap-3 sm:flex-row sm:items-center lg:shrink-0" data-id="element-804" data-mp="3gjxgezuw5adz">
            <a href={business.phoneHref} className="inline-flex items-center justify-center gap-3 whitespace-nowrap rounded-md bg-brand px-7 py-4 font-display text-lg font-bold text-white transition-colors duration-150 ease-out hover:bg-brand-light" data-id="element-805" data-mp="1ghxwezt03f0q">
              <PhoneIcon className="h-5 w-5 shrink-0" aria-hidden="true" data-id="element-806" data-mp="12k0z216q34l0" />
              Call {business.phone}
            </a>
            <Link to="/contact" className="inline-flex items-center justify-center whitespace-nowrap rounded-md border border-white/25 px-7 py-4 text-base font-semibold text-white transition-colors duration-150 ease-out hover:border-white/60" data-id="element-807" data-mp="suhdgnrmkwmg">
              Contact the Shop
            </Link>
          </div>
        </div>
      </section>
    </>;
}